import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiUrlV1 } from "../../config/config";
import { agent, encodeGetParams } from "../../api";
import { ApiQueryParams, ResponseObjectList } from "../../entities/global";
import { FortuneWheelBonus, FortuneWheelEntity, FortuneWheelProfile } from "../../entities/wheelGame_v2";
import { handlerNeedUpdate } from "./fortuneWheelTableStore";
import { addNotification } from "../Notification/notificateStore";

const wheelGameUrl = apiUrlV1 + "/v2/organization/game/fortunewheel";

export const getWheelBonuses = createAsyncThunk(
  "fotune-wheel/get-bonuses-list",
  async (params?: ApiQueryParams): Promise<ResponseObjectList<FortuneWheelBonus[]>> => {
    try {
      const query = encodeGetParams({ ...params });
      const response = await agent.get(`${wheelGameUrl}/prize/read/list${query}`);

      if (response.ok) {
        const body = (await response.json()) as ResponseObjectList<FortuneWheelBonus[]>;

        return body;
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }

    return {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
      data: [],
    };
  }
);

export const deleteWheelBonus = createAsyncThunk(
  'fotune-wheel/delete-wheel-bonus',
  async (params: { id: number }, thunksApi) => {
    try {
      const response = await agent.delete(`${wheelGameUrl}/prize/delete/${params.id}`)
      if (response.ok) {
        thunksApi.dispatch(handlerNeedUpdate({ key: 'bonus', value: true }));
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const getWheelEntites = createAsyncThunk(
  "fotune-wheel/get-entites-list",
  async (params?: ApiQueryParams): Promise<ResponseObjectList<FortuneWheelEntity[]>> => {
    try {
      const query = encodeGetParams({ ...params });
      const response = await agent.get(`${wheelGameUrl}/read/list${query}`);

      if (response.ok) {
        const body = (await response.json()) as ResponseObjectList<FortuneWheelEntity[]>;
        return body;
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }

    return {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
      data: [],
    };
  }
);
export const deleteWheelEntity = createAsyncThunk(
  'fotune-wheel/delete-wheel-entity',
  async (params: { id: number }, thunksApi) => {
    try {
      const response = await agent.delete(`${wheelGameUrl}/delete/${params.id}`)
      if (response.ok) {
        thunksApi.dispatch(handlerNeedUpdate({ key: 'entity', value: true }));
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const getWheelProfiles = createAsyncThunk(
  "fotune-wheel/get-profiles-list",
  async (params?: ApiQueryParams): Promise<ResponseObjectList<FortuneWheelProfile[]>> => {
    try {
      const query = encodeGetParams({ ...params });
      const response = await agent.get(`${apiUrlV1}/v3/organization/game/profile/read/fortuneWheel/list${query}`);

      if (response.ok) {
        const body = (await response.json()) as ResponseObjectList<FortuneWheelProfile[]>;

        return body;
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }

    return {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
      data: [],
    };
  }
);
export const deleteWheelProfile = createAsyncThunk(
  'fotune-wheel/delete-wheel-profile',
  async (params: { id: number }, thunksApi) => {
    try {
      const response = await agent.delete(`${wheelGameUrl}/profile/delete/${params.id}`)
      if (response.ok) {
        thunksApi.dispatch(handlerNeedUpdate({ key: 'profile', value: true }));
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

